let defaultState = {
    errorType: null,
    messageKey: null
};

export default function (state = defaultState, action) {
    switch (action.type) {
        case 'ERROR':
            return {
                ...state,
                errorType: "ERROR",
                messageKey: action.messageKey
            };

        case 'CLEAR_ERROR':
            return defaultState;


        default:
            return state
    }
}
